import React from 'react';
import Form from "../../../../components/form";

function useHover(styleOnHover, styleOnNotHover = {})
{
    const [style, setStyle] = React.useState(styleOnNotHover);

    const onMouseEnter = () => setStyle(styleOnHover)
    const onMouseLeave = () => setStyle(styleOnNotHover)

    return {style, onMouseEnter, onMouseLeave}
}

const PortfolioDetailsContent = ({title, category, description, meta}) => {
    const hover = useHover({textDecoration: "underline"}, {color: "#E65B1C"})

    return (
        <div className="portfolio-details-content">
            {meta.quote && (
                <blockquote>
                    <p>
                        <i>{meta.quote}</i>
                        <br/>
                        <br/>
                        <i>
                            Warmly,<br/>
                            Rio
                        </i>
                    </p>
                    <hr/>
                    <br/>
                </blockquote>
                )
            }

            {category && <p className="category">{category}</p>}
            {title && <h1 className="title">{title}</h1>}
            {description && <p>{description}</p>}

            <ul className="project-info">
                {meta.availability && <li><span>Availability:</span> {meta.availability}{meta.contact &&
                    <a href="/contact" {...hover}>{meta.contact}</a>}</li>}
                {meta.edition && <li><span>Edition:</span> {meta.edition}</li>}
                {meta.client && <li><span>Client:</span> {meta.client}</li>}
                {meta.size && <li><span>Size:</span> {meta.size}</li>}
                {meta.date && <li><span>Year:</span> {meta.date}</li>}
                {meta.location && <li><span>Location:</span> {meta.location}</li>}
                {meta.website && <li><span>Link:</span>
                    <a href={meta.website}
                       target="_blank"
                       rel="noopener noreferrer">{meta.website}
                    </a>
                </li>}
                <li>
                    <span>Materials:</span>
                    <ul className="materials">
                        {meta.materials.map((m,index) => (
                            <li key={index}>{m}</li>
                        ))}
                    </ul>
                </li>
            </ul>


            <hr/>

            {meta.contactForm && <div className="contact-form">
                <br/>
                <p className="alt-title">Message Me</p>
                <p>For prices & commissions, or if you have any questions, submit a message below.</p>
                <br/>
                <Form/>
            </div>}

            {meta.share && <div className="project-share">
                <span>Share:</span>
                <a href="https://www.facebook.com/sharer/sharer.php"><i className="fa fa-facebook"/></a>
                <a href="https://twitter.com/share"><i className="fa fa-twitter"/></a>
                {/*<a href="/"><i className="fa fa-pinterest-p"/></a>*/}
                <a
                    href="https://www.pinterest.com/pin/create/button/"
                    data-pin-do="buttonBookmark"
                    data-pin-custom="true"
                >
                    <i className="fa fa-pinterest-p"/>
                </a>
            </div>}
        </div>
    );
};

export default PortfolioDetailsContent;